var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "dropzone-upload-placeholder-svg",
    width: 128,
    height: 121,
    viewBox: "0 0 128 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 121,
    rx: 10,
    fill: "#3E6E9C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.3333 65.167V81.8336H55.6667V65.167H43.1667L64 44.3337L84.8333 65.167H72.3333ZM94.625 52.792C91.7917 38.4587 79.1667 27.667 64 27.667C51.9583 27.667 41.5 34.5003 36.2917 44.4587C23.75 45.8337 14 56.417 14 69.3337C14 75.9641 16.6339 82.3229 21.3223 87.0113C26.0107 91.6997 32.3696 94.3336 39 94.3336H93.1667C95.9025 94.3336 98.6116 93.7948 101.139 92.7478C103.667 91.7008 105.964 90.1663 107.898 88.2317C109.833 86.2972 111.367 84.0005 112.414 81.4729C113.461 78.9453 114 76.2362 114 73.5003C114 62.5003 105.458 53.5837 94.625 52.792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPlaceholder);
export default __webpack_public_path__ + "static/media/upload-placeholder.a20a7b7ec44b90ace655a59e86d86e8a.svg";
export { ForwardRef as ReactComponent };